import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CommonAuthorizedStackParamList } from '@src/navigation/types'
import { productsSelector, userSelector } from '@src/selectors/app'
import { usePromotionCode, useTaxEstimation } from '@src/screens/Marketplace/utils/hooks'
import { BillingProduct } from '@src/types'

export const useSelection = (params: CommonAuthorizedStackParamList['AddonCheckout']) => {
  const products = useSelector(productsSelector)
  const dispatch = useDispatch()

  const { selections, productKey, quantity } = params

  const productFromKey = productKey && products.find((product) => product.key === productKey)
  const finalSelections = useMemo(() => {
    return productFromKey ? [{ product: productFromKey, quantity: quantity || 1 }] : selections
  }, [productFromKey, quantity, selections])
  const selection = finalSelections && finalSelections.length > 0 ? finalSelections[0] : null
  const product = selection?.product

  const user = useSelector(userSelector)
  const address = user?.address

  const promotionCode = usePromotionCode(product?.key as BillingProduct)

  const { estimatedTax, loading } = useTaxEstimation({
    productKey: product?.key as BillingProduct,
    promotionCode,
    zipCode: address?.zipCode,
    country: address?.country,
  })

  useEffect(() => {
    dispatch({
      type: 'app/fetchProducts',
    })
  }, [dispatch])

  return {
    selection,
    product,
    lowestPricedProduct: product,
    fullPrice: product ? product.price * (selection.quantity ?? 1) : 0,
    requiresShipping: product?.requiresShipping ?? false,
    promotionCode,
    estimatedTax,
    loading: products.length === 0 || loading,
  }
}
